<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-credit-card-lock" icon-small title="احراز هویت" color="accent">
			<v-row class="mt-5 justify-center">
				<v-col cols="12" sm="10" md="8" xl="6" style="padding:0 40px 40px">
					<MemberAuthorizationManager v-if="getCurrentUser.userData.id" area="member" :member="getCurrentUser.userData" type="detail" :defaultDetailExpanded="true" />
				</v-col>
			</v-row>
		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
	</v-container>
</template>

<script>
	import { get } from 'vuex-pathify'
	import MemberAuthorizationManager from '@/components/memberAuthorization/MemberAuthorizationManager'

	export default {
		name: 'Authorization',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			MemberAuthorizationManager,
		},
		data() {
			return {
				localData: {},
			}
		},
		computed: {
			...get('auth', [
				'getCurrentUser',
			]),
		},
		mounted() {

		},
		methods: {

		},
	}
</script>
<style></style>
